import { createAction } from '@reduxjs/toolkit';
import constants from './constants';
import { CommentModerationStatsType } from '../types';

export const storeCommentModerationStats = createAction<CommentModerationStatsType>(constants.STORE_COMMENT_MODERATION_STATS);
export const storeEngagementStats = createAction<CommentModerationStatsType>(constants.STORE_ENGAGEMENT_STATS);
export const haveStatsChanged = createAction<boolean>(constants.HAVE_STATS_CHANGED);
export const setIsEngagementsViewer = createAction<boolean>(constants.IS_ENGAGEMENTS_VIEWER);
